import { gql } from 'urql';

const PayOverTimeStatement = gql`
  query PayOverTimeStatement($input: PayOverTimeDownloadStatementInput!) {
    payOverTimeStatement(input: $input) {
      __typename
      ... on PayOverTimeDownloadStatementSuccess {
        statement {
          id
          fileName
          fileSize
          createdAt
          url
        }
      }
      ... on PayOverTimeDownloadStatementError {
        code
        title
        message
      }
    }
  }
`;

export default PayOverTimeStatement;
